import { createRouter, createWebHistory } from 'vue-router'

import { recoverFromChunkError } from '@/lib/pwa/recoverFromChunkError'

import { beforeEach } from './beforeEach'
import routes from './routes'

// Re-exported so `@/router` stays the one import site for the login round trip.
export * from './postAuthRedirect'

// Router base should always be '/' for routes, even if assets are served from a different base
const routerBase = '/'

const router = createRouter({
  history: createWebHistory(routerBase),
  routes: routes.value,
})

// Add hooks
router.beforeEach(beforeEach)

// A lazy route chunk that 404s after a deploy has the same root cause as blank
// icons: a stale service-worker shell pointing at old chunk hashes. Recover by
// activating the fresh SW then reloading — a bare re-navigation would just be
// re-served the same stale shell (and had no guard against looping).
router.onError((error, to) => {
  if (
    error.message.includes('Failed to fetch dynamically imported module') ||
    error.message.includes('Importing a module script failed') ||
    error.message.includes('Unable to preload CSS') ||
    // The global `vite:preloadError` handler calls `preventDefault()`, so Vite
    // doesn't re-throw — the failed route import resolves `undefined` and
    // vue-router throws this instead. Match it so route-chunk failures still
    // reach recovery WITH the intended destination.
    error.message.includes("Couldn't resolve component")
  ) {
    // Preserve the destination the user was navigating to — recovery activates
    // the fresh SW then lands there, instead of reloading the previous route.
    void recoverFromChunkError(to?.fullPath)
  }
})

export default router
